'use client';
import Button from 'components/buttons/Button';
import React from 'react';
import { printPage } from 'utils/printPage';

const PrintButton = () => {
  const handlePrint = () => {
    printPage();
  };

  return (
    <Button
      className="print button"
      onClick={handlePrint}
      size="half-width"
      title="Print page"
      variant="underlined"
    />
  );
};

export default PrintButton;
